import AntCollapse from 'antd/lib/collapse';

const { Panel: AntPanel } = AntCollapse;

export const Panel = AntPanel;
export const Collapse = AntCollapse;
